import React, { useCallback, useEffect, useImperativeHandle, useRef, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
// @ts-ignore
import Loader from "react-spinner-loader"
import { Container } from "reactstrap"
import { gamesLookupService } from "../../../modules/games/games-lookup"
import { ActivityGame, GameProvider } from "../../../modules/games/game"
import { BASE_URL } from "../../../global"
import { apiClient } from "../../../infra/api-client"
import { ActivityInfo } from "../../../modules/lesson/activity/activity.types"
import { AracdemicsGame } from "./game-arcademics"
import { getUserSession } from "../../../common/session/user-session"
import { stringToBoolean } from "../../../common/utils/common-utils"

type GameContextType = {
  isActivityMode: boolean,
  isSelfMode: boolean,
}

export const GameContext = React.createContext<GameContextType | null>(null)

type HeaderProp = {
  title: React.ReactElement | string | undefined;
  activity: ActivityInfo | null;
  activityTypeName: string;
}


const Header = ({ title, activity, activityTypeName }: HeaderProp) => {

  return (
    <Container className="custom-wt">
      <div className="d-flex align-items-center">
        <div className="mt-0 border-right me-4" style={{ width: "20%" }}>
          <div
            className="text-white font-size-14 text-uppercase cursor-pointer"
            onClick={() => history.back()}
          >
            {" "}
            <span><i className=" fas fa-chevron-left me-1"></i></span>
            {" "}
            Back
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between flex-grow-1">
          <h6 className="mb-0 font-size-20 text-white w-60 fw-regular">
            {title}
          </h6>
          <p className="mb-0 text-uppercase luminous-wht">
            {" "}
            <span className="text-yellow me-1">
              {activity?.subject_name}
            </span>{" "}
            {activityTypeName}
            {" "}
          </p>
          {/*<div className="luminous-wht font-size-16">*/}
          {/*  <img width={24} className="" src={awicon} alt="" />{" "}*/}
          {/*  {ActivityData && ActivityData.coins_earned*/}
          {/*    ? ActivityData.coins_earned*/}
          {/*    : 0}*/}
          {/*  /*/}
          {/*  {ActivityData &&*/}
          {/*  ActivityData.LessonActivitiesQuestions &&*/}
          {/*  ActivityData.LessonActivitiesQuestions.length > 0*/}
          {/*    ? CountTotalCoins(ActivityData.LessonActivitiesQuestions)*/}
          {/*    : 0}{" "}*/}
          {/*  coins*/}
          {/*</div>*/}
        </div>
      </div>
    </Container>

  )
}

export type SubmitProviderResponse = {
  providerId: string
  providerGameId: string
  providerResponse?: any
  gameSessionId: string
}
export type SubmitGameStarted = {
  providerId: string
  providerGameId: string
  providerResponse?: any
  gameSessionId: string
}



type GamePageProps = {}

export const GamePage = React.memo((props: GamePageProps) => {

    // const { activity_key } = useParams()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const subject = searchParams.get("subject")
    const activity_key = searchParams.get("activityKey")
    const isActivityMode = searchParams.get("mode") === "activity";
    const isSelfMode = searchParams.get("mode") !== "activity";

    const [activity, setActivity] = useState<ActivityInfo | null>(null)
    const [game, setGame] = useState<ActivityGame>()
    const [loading, setLoading] = useState<boolean>(false)
    const navigate = useNavigate()

    const timeStart = useRef<number | null>(null)

    useEffect(() => {
      if(isActivityMode) {
        fetchData()
          .then((activity: ActivityInfo) => {
            setActivity(activity)
            gamesLookupService.getGames().then(games => {
              const _game = games.find(game => game.id === activity.fk_activity_node_id)
              setGame(_game)
            })
          })
      }
      else if(isSelfMode) {
        const providerId = searchParams.get("providerId")!
        const providerGameId = searchParams.get("providerGameId")!
        gamesLookupService.getProviderGame({providerId, providerGameId})
          .then( _game => {
            if(_game){
              setGame(_game)
            }
            else {
              console.info(`cannot find game for ${providerId}/${providerGameId}`);
            }
          })
      }
    }, [])

    const setGameStarted = useCallback(() => {
      timeStart.current = Date.now()
    }, [game])

    const fetchData = async () => {
      try {
        setLoading(true)
        return apiClient
          .post(BASE_URL + "studentSession/StudentAssessmentQuestions", {
            pk_activity_key: activity_key,
            subject_id: subject
          })
          .then(response => {
            return response.data
          })
      } finally {
        setLoading(false)
      }
    }

    const onGameEnded = useCallback(() => {
      if(isActivityMode) {
        const homework = stringToBoolean(searchParams.get("homework"))
        let url = ""
        if (homework) {
          url = "/homework-list"
        } else {
          const sessionKey = searchParams.get("session_key")
          url = `/lesson-plan/${sessionKey}`
        }
        navigate(url)
      }
      else if(isSelfMode){
        history.go(-2);
      }
    }, [])

    const submitSessionResult = useCallback(async (gameData: SubmitProviderResponse) => {
      const timeEnd = Date.now()
      const duration = timeStart.current ? (Math.floor((timeEnd - timeStart.current!) / 1000)) : 0

      const {centerKey, studentKey} = getUserSession()

      const data = {
        student_key: studentKey,
        lesson_key: activity?.fk_lesson_key,
        center_key: centerKey,
        lesson_activity_key: activity?.pk_lesson_activity_key,
        subject_id: activity?.fk_sub_id,
        session_key: activity?.fk_sest_key,
        time_spent: duration,
        provider_id: gameData.providerId,
        provider_game_id: gameData.providerGameId,
        provider_response: gameData.providerResponse,
        mode: isActivityMode ? "activity" : "self",
        game_session_id: gameData.gameSessionId,
      }

      return apiClient.post(BASE_URL + "games/submitSessionResult", data)
        .then(response => {

        })
    }, [activity])

    const submitGameStarted = useCallback(async (gameData: SubmitGameStarted) => {
      const timeEnd = Date.now()
      const duration = timeStart.current ? (Math.floor((timeEnd - timeStart.current!) / 1000)) : 0

      const {centerKey, studentKey} = getUserSession()

      const data = {
        student_key: studentKey,
        lesson_key: activity?.fk_lesson_key,
        center_key: centerKey,
        lesson_activity_key: activity?.pk_lesson_activity_key,
        subject_id: activity?.fk_sub_id,
        session_key: activity?.fk_sest_key,
        time_spent: duration,
        provider_id: gameData.providerId,
        provider_game_id: gameData.providerGameId,
        mode: isActivityMode ? "activity" : "self",
        game_session_id: gameData.gameSessionId,
      }

      return apiClient.post(BASE_URL + "games/saveGameStarted", data)
        .then(response => {

        })
    }, [activity])


    return (
      <div>
        <Loader show={loading} type="body" />

        <div className="page-wrapper">
          <div className="cs-pg-header bg-dark-blue py-4">
            <Header
              title={game?.name}
              activity={activity} activityTypeName={"Game"}
            ></Header>
          </div>
        </div>

        <GameContext.Provider value={{ isSelfMode, isActivityMode }}>
          {game && game.providerId === GameProvider.ARCADEMICS &&
            <AracdemicsGame
              activity={activity} game={game}
              setGameStarted={setGameStarted}
              submitSessionResult={submitSessionResult}
              submitGameStarted={submitGameStarted}
              onGameEndedCallback={onGameEnded}
            >
            </AracdemicsGame>
          }
        </GameContext.Provider>
      </div>
    )

  }
)